function a(c, e, t) {
  return typeof c === e ? () => c : typeof c == "function" ? c : t;
}
class x {
  constructor(e, { hostDelegatesFocus: t, direction: s, elementEnterAction: n, elements: o, focusInIndex: d, isFocusableElement: u, listenerScope: l } = { elements: () => [] }) {
    this._currentIndex = -1, this.prevIndex = -1, this._direction = () => "both", this.directionLength = 5, this.hostDelegatesFocus = !1, this.elementEnterAction = (i) => {
    }, this._focused = !1, this._focusInIndex = (i) => 0, this.isFocusableElement = (i) => !0, this._listenerScope = () => this.host, this.offset = 0, this.recentlyConnected = !1, this.handleFocusin = (i) => {
      if (!this.isEventWithinListenerScope(i)) return;
      const r = i.composedPath();
      let h = -1;
      r.find((m) => (h = this.elements.indexOf(m), h !== -1)), this.prevIndex = this.currentIndex, this.currentIndex = h > -1 ? h : this.currentIndex, this.isRelatedTargetOrContainAnElement(i) && this.hostContainsFocus();
    }, this.handleClick = () => {
      var i;
      const r = this.elements;
      if (!r.length) return;
      let h = r[this.currentIndex];
      this.currentIndex < 0 || ((!h || !this.isFocusableElement(h)) && (this.setCurrentIndexCircularly(1), h = r[this.currentIndex]), h && this.isFocusableElement(h) && ((i = r[this.prevIndex]) == null || i.setAttribute("tabindex", "-1"), h.setAttribute("tabindex", "0")));
    }, this.handleFocusout = (i) => {
      this.isRelatedTargetOrContainAnElement(i) && this.hostNoLongerContainsFocus();
    }, this.handleKeydown = (i) => {
      if (!this.acceptsEventKey(i.key) || i.defaultPrevented) return;
      let r = 0;
      switch (this.prevIndex = this.currentIndex, i.key) {
        case "ArrowRight":
          r += 1;
          break;
        case "ArrowDown":
          r += this.direction === "grid" ? this.directionLength : 1;
          break;
        case "ArrowLeft":
          r -= 1;
          break;
        case "ArrowUp":
          r -= this.direction === "grid" ? this.directionLength : 1;
          break;
        case "End":
          this.currentIndex = 0, r -= 1;
          break;
        case "Home":
          this.currentIndex = this.elements.length - 1, r += 1;
      }
      i.preventDefault(), this.direction === "grid" && this.currentIndex + r < 0 ? this.currentIndex = 0 : this.direction === "grid" && this.currentIndex + r > this.elements.length - 1 ? this.currentIndex = this.elements.length - 1 : this.setCurrentIndexCircularly(r), this.elementEnterAction(this.elements[this.currentIndex]), this.focus();
    }, this.mutationObserver = new MutationObserver(() => {
      this.handleItemMutation();
    }), this.hostDelegatesFocus = t || !1, this.host = e, this.host.addController(this), this._elements = o, this.isFocusableElement = u || this.isFocusableElement, this._direction = a(s, "string", this._direction), this.elementEnterAction = n || this.elementEnterAction, this._focusInIndex = a(d, "number", this._focusInIndex), this._listenerScope = a(l, "object", this._listenerScope);
  }
  get currentIndex() {
    return this._currentIndex === -1 && (this._currentIndex = this.focusInIndex), this._currentIndex - this.offset;
  }
  set currentIndex(e) {
    this._currentIndex = e + this.offset;
  }
  get direction() {
    return this._direction();
  }
  get elements() {
    return this.cachedElements || (this.cachedElements = this._elements()), this.cachedElements;
  }
  set focused(e) {
    e !== this.focused && (this._focused = e);
  }
  get focused() {
    return this._focused;
  }
  get focusInElement() {
    return this.elements[this.focusInIndex];
  }
  get focusInIndex() {
    return this._focusInIndex(this.elements);
  }
  isEventWithinListenerScope(e) {
    return this._listenerScope() === this.host || e.composedPath().includes(this._listenerScope());
  }
  handleItemMutation() {
    if (this._currentIndex == -1 || this.elements.length <= this._elements().length) return;
    const e = this.elements[this.currentIndex];
    if (this.clearElementCache(), this.elements.includes(e)) return;
    const t = this.currentIndex !== this.elements.length, s = t ? 1 : -1;
    t && this.setCurrentIndexCircularly(-1), this.setCurrentIndexCircularly(s), this.focus();
  }
  update({ elements: e } = { elements: () => [] }) {
    this.unmanage(), this._elements = e, this.clearElementCache(), this.manage();
  }
  reset() {
    var e;
    const t = this.elements;
    if (!t.length) return;
    this.setCurrentIndexCircularly(this.focusInIndex - this.currentIndex);
    let s = t[this.currentIndex];
    this.currentIndex < 0 || ((!s || !this.isFocusableElement(s)) && (this.setCurrentIndexCircularly(1), s = t[this.currentIndex]), s && this.isFocusableElement(s) && ((e = t[this.prevIndex]) == null || e.setAttribute("tabindex", "-1"), s.setAttribute("tabindex", "0")));
  }
  focusOnItem(e, t) {
    var s;
    const n = this.elements || [], o = e && this.isFocusableElement(e) ? n.indexOf(e) : -1;
    o > -1 && (this.currentIndex = o, (s = n[this.prevIndex]) == null || s.setAttribute("tabindex", "-1")), this.focus(t);
  }
  focus(e) {
    var t;
    const s = this.elements;
    if (!s.length) return;
    let n = s[this.currentIndex];
    (!n || !this.isFocusableElement(n)) && (this.setCurrentIndexCircularly(1), n = s[this.currentIndex]), n && this.isFocusableElement(n) && ((!this.hostDelegatesFocus || s[this.prevIndex] !== n) && ((t = s[this.prevIndex]) == null || t.setAttribute("tabindex", "-1")), n.tabIndex = 0, n.focus(e), this.hostDelegatesFocus && !this.focused && this.hostContainsFocus());
  }
  clearElementCache(e = 0) {
    this.mutationObserver.disconnect(), delete this.cachedElements, this.offset = e, requestAnimationFrame(() => {
      this.elements.forEach((t) => {
        this.mutationObserver.observe(t, { attributes: !0 });
      });
    });
  }
  setCurrentIndexCircularly(e) {
    const { length: t } = this.elements;
    let s = t;
    this.prevIndex = this.currentIndex;
    let n = (t + this.currentIndex + e) % t;
    for (; s && this.elements[n] && !this.isFocusableElement(this.elements[n]); ) n = (t + n + e) % t, s -= 1;
    this.currentIndex = n;
  }
  hostContainsFocus() {
    this.host.addEventListener("focusout", this.handleFocusout), this.host.addEventListener("keydown", this.handleKeydown), this.focused = !0;
  }
  hostNoLongerContainsFocus() {
    this.host.addEventListener("focusin", this.handleFocusin), this.host.removeEventListener("focusout", this.handleFocusout), this.host.removeEventListener("keydown", this.handleKeydown), this.focused = !1;
  }
  isRelatedTargetOrContainAnElement(e) {
    const t = e.relatedTarget, s = this.elements.includes(t), n = this.elements.some((o) => o.contains(t));
    return !(s || n);
  }
  acceptsEventKey(e) {
    if (e === "End" || e === "Home") return !0;
    switch (this.direction) {
      case "horizontal":
        return e === "ArrowLeft" || e === "ArrowRight";
      case "vertical":
        return e === "ArrowUp" || e === "ArrowDown";
      case "both":
      case "grid":
        return e.startsWith("Arrow");
    }
  }
  manage() {
    this.addEventListeners();
  }
  unmanage() {
    this.removeEventListeners();
  }
  addEventListeners() {
    this.host.addEventListener("focusin", this.handleFocusin), this.host.addEventListener("click", this.handleClick);
  }
  removeEventListeners() {
    this.host.removeEventListener("focusin", this.handleFocusin), this.host.removeEventListener("focusout", this.handleFocusout), this.host.removeEventListener("keydown", this.handleKeydown), this.host.removeEventListener("click", this.handleClick);
  }
  hostConnected() {
    this.recentlyConnected = !0, this.addEventListeners();
  }
  hostDisconnected() {
    this.mutationObserver.disconnect(), this.removeEventListeners();
  }
  hostUpdated() {
    this.recentlyConnected && (this.recentlyConnected = !1, this.elements.forEach((e) => {
      this.mutationObserver.observe(e, { attributes: !0 });
    }));
  }
}
class I extends x {
  constructor() {
    super(...arguments), this.managed = !0, this.manageIndexesAnimationFrame = 0;
  }
  set focused(e) {
    e !== this.focused && (super.focused = e, this.manageTabindexes());
  }
  get focused() {
    return super.focused;
  }
  clearElementCache(e = 0) {
    cancelAnimationFrame(this.manageIndexesAnimationFrame), super.clearElementCache(e), this.managed && (this.manageIndexesAnimationFrame = requestAnimationFrame(() => this.manageTabindexes()));
  }
  manageTabindexes() {
    this.focused && !this.hostDelegatesFocus ? this.updateTabindexes(() => ({ tabIndex: -1 })) : this.updateTabindexes((e) => ({ removeTabIndex: e.contains(this.focusInElement) && e !== this.focusInElement, tabIndex: e === this.focusInElement ? 0 : -1 }));
  }
  updateTabindexes(e) {
    this.elements.forEach((t) => {
      const { tabIndex: s, removeTabIndex: n } = e(t);
      if (!n) return void (this.focused ? t !== this.elements[this.currentIndex] && (t.tabIndex = s) : t.tabIndex = s);
      const o = t;
      o.requestUpdate && o.requestUpdate();
    });
  }
  manage() {
    this.managed = !0, this.manageTabindexes(), super.manage();
  }
  unmanage() {
    this.managed = !1, this.updateTabindexes(() => ({ tabIndex: 0 })), super.unmanage();
  }
  hostUpdated() {
    super.hostUpdated(), this.host.hasUpdated || this.manageTabindexes();
  }
}
export {
  x as F,
  I as R
};
//# sourceMappingURL=RovingTabindex-CaJGAPVE.js.map
